import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const ElSalvadorFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14663'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14663)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#1B57C4'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#1B57C4'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.85757 5.50659C8.39495 5.84715 8.0957 6.38935 8.0957 7.00003C8.0957 8.03097 8.94849 8.8667 10.0005 8.8667C11.0524 8.8667 11.9052 8.03097 11.9052 7.00003C11.9052 6.38935 11.606 5.84715 11.1434 5.50659L10.4767 7.4667H9.52427L8.85757 5.50659Z'
					fill='url(#paint0_linear_2332_14663)'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99963 5.1333L10.4758 7.46663H9.52344L9.99963 5.1333Z'
					fill='#F9C92E'
				/>
			</g>
			<defs>
				<linearGradient
					id='paint0_linear_2332_14663'
					x1='8.0957'
					y1='5.50659'
					x2='8.0957'
					y2='8.8667'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#3C7839' />
					<stop
						offset='1'
						stopColor='#31642E'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default ElSalvadorFlagIcon;
